import React from "react"
import PropTypes from "prop-types"
import {Button, Card, Table, Badge, Tooltip} from "antd"
import {bindActionCreators} from "redux";
import { uniq } from 'lodash';
import * as SelectionActions from "../reducers/selection_builder";
import connect from "react-redux/es/connect/connect";
import {withRouter} from "react-router";
import {compose} from "recompose";
import CreationSelectionDrawer from "./create/SelectionCreationDrawer";
import UpdateSelectionDrawer from "./update/SelectionUpdateDrawer";

class SelectionOverview extends React.PureComponent {

    static propTypes = {
        overview: PropTypes.array.isRequired,
        populate: PropTypes.array.isRequired,
        getOverview: PropTypes.func.isRequired,
        loadSelections: PropTypes.func.isRequired,
        deactivateSelection: PropTypes.func.isRequired,
        overviewLoader: PropTypes.bool.isRequired,

    };

    state = {
        showCreationDrawer: false,
        showUpdateDrawer: false,
        record: null
    };

    componentDidMount() {
        this.props.getOverview();
    }

    handleSelection = (e, record) => {
        e.preventDefault();
        this.props.history.push(`/selection/builder/${record.id}`);
        this.props.loadSelections(record.id);
    };


    handleUpdateSelection = (e, record) => {
        e.preventDefault();
        this.setState(state => ({showUpdateDrawer: !state.showUpdateDrawer, record: record.id}));
    };



    toggleCreationDrawer = () => this.setState(state => ({showCreationDrawer: !state.showCreationDrawer}));
    toggleUpdateDrawer = () => this.setState(state => ({showUpdateDrawer: !state.showUpdateDrawer}));

    render() {
        const {overview, overviewLoader, isAdmin} = this.props;
        const {showCreationDrawer, showUpdateDrawer, record} = this.state;
        console.log('isAdmin', this.props.isAdmin);
        const toEdit = overview.overview.filter(x => x.id === record)[0] || {};

        const columns = [
            {title: 'Active', dataIndex: 'active', render: active => <Badge status={active ? 'success' : 'default'}/>},
            {title: 'Name', dataIndex: 'name',
                filters: uniq(overview.overview.map(selection => selection.name)).sort().map(name => ({
                    text: name,
                    value: name,
                })),
                onFilter: (value, record) => record.name.indexOf(value) === 0,
            },
            {title: 'Customer', dataIndex: 'customer',
                filters: uniq(overview.overview.map(selection => selection.customer)).sort().map(customer => ({
                    text: customer,
                    value: customer,
                })),
                onFilter: (value, record) => record.customer.indexOf(value) === 0,},
            {title: 'Type', dataIndex: 'type',
                filters: uniq(overview.overview.map(selection => selection.type)).sort().map(type => ({
                    text: type,
                    value: type,
                })),
                onFilter: (value, record) => record.type.indexOf(value) === 0,
            },
            {title: 'Persons In Selection', dataIndex: 'personsInSelection'},
            {title: 'Sites In Selection', dataIndex: 'sitesInSelection'},
            {
                render: (record) => <div className="crud-options"><Button type="primary" onClick={e => this.handleSelection(e, record)}>
                    Open
                </Button>
                    <Tooltip title="Edit selection"><Button disabled={!isAdmin} icon="edit" size="small"  shape="circle" onClick={e => this.handleUpdateSelection(e, record)}/></Tooltip>
                </div>
            }
        ];
        return <Card title="Overview">
            <Table columns={columns} dataSource={overview.overview} loading={overviewLoader}/>
            <CreationSelectionDrawer visible={showCreationDrawer} customers={overview.customers} type={overview.type} toggleVisibility={this.toggleCreationDrawer}/>
            <UpdateSelectionDrawer visible={showUpdateDrawer} customers={overview.customers} type={overview.type} toEdit={toEdit} toggleVisibility={this.toggleUpdateDrawer}/>
            <Tooltip title="Create new selection"><Button disabled={!isAdmin} icon="plus" size="large" shape="circle" onClick={this.toggleCreationDrawer}/></Tooltip>
        </Card>
    }
}

const mapStateToProps = state => ({
    overview: state.selection_builder.overview,
    overviewLoader: state.selection_builder.overviewLoader,
    isAdmin: state.auth.isAdmin,
});

const mapDispatchToProps = dispatch => ({
    getOverview: bindActionCreators(SelectionActions, dispatch).getOverview,
    loadSelections: bindActionCreators(SelectionActions, dispatch).getSelections,
/*    deactivateSelection:bindActionCreators(SelectionActions, dispatch).deactivateSelection*/
});

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
)(SelectionOverview);



// WEBPACK FOOTER //
// ./src/js/selection/SelectionOverview.js